import React from "react";
import { Container } from "../../components/listing/AMSListing";
import { SkeletonCell } from "../../components/SkeletonCell";
import { useTheme } from "../../middleware/ThemeContext";
import styled from "styled-components";

const MergeDuplicateSkeleton = () => {
    const {theme} = useTheme();
    return (
        <div>
            <Container theme={theme} className='rounded-0 d-flex justify-content-between'>
                        <div>
                            <SkeletonCell height="20px" style={{ width: '250px', marginBottom: '10px' }} />
                            <SkeletonCell height="16px" style={{ width: '250px' }} />
                        </div>
                        <div>
                            <SkeletonCell style={{ height: '42px', width: '134px' }} />
                        </div>
            </Container>
            <div className="container-fluid" style={{ backgroundColor: theme.CorporateTheme.colors.bannerBg, height: 'calc(100vh - 205px)' }}>
                    <div className="row pt-4 px-2">
                    <div className="col-9">
                        <SkeletonCell style={{ height: '15px', width: '100px' }} />
                        <WhiteContainer theme={theme} style={{ height: 'calc(100vh - 290px)', overflow: 'auto' }}>
                            <SingleResult theme={theme}>
                            {[...Array(4)].map((_, j) => (
                                <div key={j} className='col-3' style={{ padding: '0px 12px' }}>
                                    <ProfileContainer theme={theme}>
                                        <SkeletonCell style={{ borderRadius: '50%', width: '34px', height: '34px', marginRight: '5px' }} />
                                        <div>
                                            <SkeletonCell style={{ height: '15px', width: '100px', marginBottom: '5px' }} />
                                            <SkeletonCell style={{ height: '15px', width: '50px' }} />
                                        </div>
                                    </ProfileContainer>
                                    <Fields theme={theme}>
                                        {[...Array(5)].map((_, i) => (
                                            <div key={i} style={{ padding: '10px 0px' }}>
                                                {/* <SkeletonCell style={{ height: '16px', width: '100px', marginBottom: '5px' }} /> */}
                                                <SkeletonCell style={{ height: '40px', width: '100%' }} />
                                            </div>
                                        ))}
                                    </Fields>
                                </div>
                            ))}
                            </SingleResult>
                        </WhiteContainer>
                    </div>
                    <div className="col-3">
                        <SkeletonCell style={{ height: '15px', width: '100px' }} />
                                {/* <MergePreview data={selectedData} columns={allFields} /> */}
                        <BackgroundCon theme={theme} style={{ height: 'calc(100vh - 290px)', overflow: 'auto' }}>
                                <div>
                                    <ProfileCon theme={theme} >
                                        <SkeletonCell style={{ borderRadius: '50%', width: '34px', height: '34px', marginRight: '5px' }} />
                                        <div>
                                            <SkeletonCell style={{ height: '15px', width: '100px', marginBottom: '5px' }} />
                                            <SkeletonCell style={{ height: '15px', width: '50px' }} />
                                        </div>
                                    </ProfileCon>
                                    <Fields theme={theme}>
                                        {[...Array(5)].map((_, i) => (
                                            <div key={i} style={{ padding: '10px 0px' }}>
                                                <SkeletonCell style={{ height: '16px', width: '100px', marginBottom: '5px' }} />
                                                <SkeletonCell style={{ height: '16px', width: '100px' }} />
                                            </div>
                                        ))}
                                    </Fields>
                                </div>
                        </BackgroundCon>
                    </div>
                    </div>
            </div>
        </div>
    )
}

const WhiteContainer = styled('div')(({ theme }) => ({
  backgroundColor: theme.colors.contentBackground,
  borderRadius: '5px',
  padding: '12px 2px',
  marginTop: '20px',
}));

const BackgroundCon = styled.div`
    border-radius: 5px;
    padding: 12px 20px;
    margin-top: 20px;
    border: 1px solid ${({theme}) => theme.CorporateTheme.colors.count};
    background: ${({theme}) => theme.colors.contentBackground};
    position: relative;
    z-index: 1;

    // &:before {
    //     content: '';
    //     background: ${({theme}) => theme.CorporateTheme.colors.containerShadow};
    //     width: 100%;
    //     height: 100%;
    //     position: absolute;
    //     top: 0;
    //     left: 0;
    //     z-index: 0;
    // }
`;
const ProfileCon = styled.div`
    display: flex;
    justify-content: center;
    margin-bottom: 10px;
    padding-bottom: 10px;
    position: relative;
    &:after {
        content: '';
        width: 80%;
        height: 1px;
        background-color: ${({theme}) => theme.CorporateTheme.colors.border};
        position: absolute;
        bottom: 0;
    }
`;
const ProfileContainer = styled.div`
    cursor: pointer;
    display: flex;
    align-items: center;
    // justify-content: space-between;
    border-bottom: 1px solid ${({theme}) => theme.CorporateTheme.colors.border};
    margin-bottom: 10px;
    padding-bottom: 10px;
`;
const Fields = styled.div`
    & > div:not(:last-child) {
        border-bottom: 1px solid ${({theme}) => theme.CorporateTheme.colors.border};
    }
`;
const SingleResult = styled.div`
    // padding: 0px 12px;
    display: flex;
    & > div:not(:last-child) {
        border-right: 1px solid ${({theme}) => theme.CorporateTheme.colors.border};
    }
`;
export default MergeDuplicateSkeleton;